// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-component {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/supervision components/image/image.component.scss","webpack://./src/components/supervision%20components/image/image.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;ACCJ","sourcesContent":[".image-component {\n    position: relative;\n}",".image-component {\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
